import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import DialogContent from "@material-ui/core/DialogContent";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Autocomplete from "@material-ui/lab/Autocomplete";
import BotService from "../../../../../services/BotService/BotService";
import TextField from '@material-ui/core/TextField';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: "#FCFCFC",
    },
}));

const StepFour = (props) => {
    const { t } = useTranslation();
    const classes = useStyles();
    const [application, setApplication] = useState([]);
    const [applicationTypes, setApplicationTypes] = useState({ Source: '', Destination: '', Application: '' });
    const [category, setCategory] = useState([]);
    const [process, setProcess] = useState([]);
    const [processVal, setProcessVal] = useState([]);
    const [categoryVal, setCategoryVal] = useState([]);
    const [appVal, setAppVal] = useState([]);
    const [automTypeName, setAutomTypeName] = useState("");
    const [destinationAppVal, setDestinationAppVal] = useState([]);
    const [sourceAppVal, setSourceAppVal] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            let t = { Source: '', Destination: '', Application: '' };
            const result = await BotService.getBotApplicationTypes();
            if (result.code === 200) {
                result.data.map(ap => {
                    t[ap.name] = ap.id;
                });
                setApplicationTypes(t);
            }

            let typeName = "";
            let ls = localStorage.getItem("automType");
            if (ls) {
                const filter = JSON.parse(ls).filter(
                    (i) =>
                        i?.id === props?.publishDetail?.publish_detail?.automation_types_id
                );
                if (filter?.length > 0) {
                    setAutomTypeName(filter[0]?.name);
                    typeName = filter[0]?.name;
                }
            }

            if (props.publishDetail.publish_detail.type !== "library") {
                BotService.getApplicationFilter().then((response) => {
                    if (response) {
                        if (response.data) {
                            if (response.data?.length > 0) {
                                setApplication(response.data);
                            } else {
                                setApplication([response.data]);
                            }
                            if (typeName.toLowerCase() === "integration") {
                                let filteredDataSource = props.publishDetail.publish_detail[
                                    "applications"
                                ].map(
                                    (item) =>
                                        item?.application_type_id === t.Source &&
                                        response.data.filter((itx) => itx.id === item.id)
                                );
                                let filterSource = filteredDataSource.map((item) => item[0]);
                                const filteredNullSource = filterSource.filter(function (el) {
                                    return el != null;
                                });

                                setSourceAppVal(filteredNullSource);

                                let filteredDestinationVal = props.publishDetail.publish_detail[
                                    "applications"
                                ].map(
                                    (item) =>
                                        item?.application_type_id === t.Destination &&
                                        response.data.filter((itx) => itx.id === item.id)
                                );
                                let filterDestination = filteredDestinationVal.map(
                                    (item) => item[0]
                                );
                                const filteredNullDestination = filterDestination.filter(function (
                                    el
                                ) {
                                    return el != null;
                                });
                                setDestinationAppVal(filteredNullDestination);
                            } else if (
                                typeName.toLowerCase() === "bot" ||
                                typeName.toLowerCase() === "library"
                            ) {
                                let filteredData = props.publishDetail.publish_detail[
                                    "applications"
                                ].map((item) => response.data.filter((itx) => itx.id === item.id));
                                let filter = filteredData.map((item) => item[0]);

                                setAppVal(filter);
                            }
                        }
                    }
                });

                BotService.getBotBusinessProcess().then((response) => {
                    if (response) {
                        if (response.data) {
                            response.data.length > 0
                                ? setProcess(response.data)
                                : setProcess([response.data]);
                            if (
                                props.publishDetail.publish_detail["business_process_id"].length > 0
                            ) {
                                let filteredData = props.publishDetail.publish_detail[
                                    "business_process_id"
                                ].map((item) => response.data.filter((itx) => itx.id === item));
                                let filter = filteredData.map((item) => item[0]);
                                setProcessVal(filter);
                            }
                        }
                    }
                });

                BotService.getCategoryFilter().then((response) => {
                    if (response) {
                        if (response.data) {
                            response.data.length > 0
                                ? setCategory(response.data)
                                : setCategory([response.data]);
                            if (props.publishDetail.publish_detail["categories"].length > 0) {
                                let filteredData = props.publishDetail.publish_detail[
                                    "categories"
                                ].map((item) => response.data.filter((itx) => itx.id === item));
                                let filter = filteredData.map((item) => item[0]);
                                setCategoryVal(filter);
                            }
                        }
                    }
                });
            }
        }
        fetchData().then(r => r);

    }, []);

    useEffect(() => {
        let newCategoryVal = categoryVal.map((item) => item.id);
        let newAppVal = appVal.map((item) => ({
            id: item.id,
            application_type_id: applicationTypes.Application,
        }));
        let newProcessVal = processVal.map((item) => item.id);
        let newSource = sourceAppVal.map((item) => ({
            id: item.id,
            application_type_id: applicationTypes.Source,
        }));
        let newDestination = destinationAppVal.map((item) => ({
            id: item.id,
            application_type_id: applicationTypes.Destination,
        }));

        if (
            automTypeName?.toLowerCase() === "library" ||
            automTypeName?.toLowerCase() === "bot" ||
            props.publishDetail.publish_detail.type.action
        ) {
            props.setPublishDetail((oldState) => ({
                publish_detail: {
                    ...oldState.publish_detail,
                    applications: newAppVal, // change dn
                    business_process_id: newProcessVal,
                    categories: newCategoryVal,
                },
            }));
            if (
                newCategoryVal.length > 0 &&
                newAppVal.length > 0 &&
                newProcessVal.length > 0
            ) {
                props.setIsRequired(false);
            } else {
                props.setIsRequired(true);
            }
        } else if (automTypeName?.toLowerCase() === "integration") {
            const newArr = [...newDestination, ...newSource];

            props.setPublishDetail((oldState) => ({
                publish_detail: {
                    ...oldState.publish_detail,
                    applications: newArr, // change dn
                    business_process_id: newProcessVal,
                    categories: newCategoryVal,
                },
            }));

            if (
                newCategoryVal.length > 0 &&
                sourceAppVal.length > 0 &&
                destinationAppVal.length > 0 &&
                newProcessVal.length > 0
            ) {
                props.setIsRequired(false);
            } else {
                props.setIsRequired(true);
            }
        }
    }, [appVal, processVal, categoryVal, destinationAppVal, sourceAppVal]);

    return (
        <DialogContent style={{ padding: "20px 0 0 0" }}>
            <Grid container>
                <Grid item xs={12}>
                    <span className="dialog-text">{t("CONTENT.PUBLISH.CATEGORY")}</span>
                    <div className={classes.root}>
                        <Autocomplete
                            multiple
                            id="tags-outlined1"
                            value={categoryVal}
                            options={category}
                            getOptionLabel={(option) => {
                                //filter value
                                return `${option.name}`;
                            }}
                            size="small"
                            onChange={(event, value) => setCategoryVal(value)}
                            filterSelectedOptions
                            renderInput={(params) => (
                                <TextField {...params} variant="outlined" />
                            )}
                        />
                    </div>
                </Grid>

                <Grid item xs={12} style={{ marginTop: "1rem" }}>
                    <span className="dialog-text">
                        {t("CONTENT.PUBLISH.BUSINESS-PROCESS")}
                    </span>
                    <div className={classes.root}>
                        <Autocomplete
                            multiple
                            id="tags-outlined2"
                            value={processVal}
                            options={process}
                            getOptionLabel={(option) => {
                                //filter value
                                return `${option.name}`;
                            }}
                            size="small"
                            onChange={(event, value) => setProcessVal(value)}
                            filterSelectedOptions
                            renderInput={(params) => (
                                <TextField {...params} variant="outlined" />
                            )}
                        />
                    </div>
                </Grid>
                {automTypeName?.toLowerCase() === "library" ||
                    automTypeName?.toLowerCase() === "bot" ||
                    props.publishDetail.publish_detail.type.action ? (
                    <Grid item xs={12} style={{ marginTop: "1rem" }}>
                        <span className="dialog-text">
                            {t("CONTENT.PUBLISH.APPLICATION")}
                        </span>
                        <div className={classes.root}>
                            <Autocomplete
                                multiple
                                id="tags-outlined3"
                                options={application}
                                value={appVal}
                                getOptionLabel={(option) => {
                                    //filter value
                                    return `${option.name}`;
                                }}
                                size="small"
                                onChange={(event, value) => setAppVal(value)}
                                filterSelectedOptions
                                renderInput={(params) => (
                                    <TextField {...params} variant="outlined" />
                                )}
                            />
                        </div>
                    </Grid>
                ) : null}
                {(automTypeName?.toLowerCase() === "integration") ? (
                    <>
                        <Grid item xs={12} style={{ marginTop: "1rem" }}>
                            <span className="dialog-text">
                                {t("CONTENT.PUBLISH.SOURCE-APP")}
                            </span>
                            <div className={classes.root}>
                                <Autocomplete
                                    multiple
                                    id="tags-outlined4"
                                    options={application}
                                    value={sourceAppVal}
                                    getOptionLabel={(option) => {
                                        //filter value
                                        return `${option.name}`;
                                    }}
                                    size="small"
                                    onChange={(event, value) => setSourceAppVal(value)}
                                    filterSelectedOptions
                                    renderInput={(params) => (
                                        <TextField {...params} variant="outlined" />
                                    )}
                                />
                            </div>
                        </Grid>
                        <Grid item xs={12} style={{ marginTop: "1rem" }}>
                            <span className="dialog-text">
                                {t("CONTENT.PUBLISH.DESTINATION-APP")}
                            </span>
                            <div className={classes.root}>
                                <Autocomplete
                                    multiple
                                    id="tags-outlined5"
                                    options={application}
                                    value={destinationAppVal}
                                    getOptionLabel={(option) => {
                                        //filter value
                                        return `${option.name}`;
                                    }}
                                    size="small"
                                    onChange={(event, value) => setDestinationAppVal(value)}
                                    filterSelectedOptions
                                    renderInput={(params) => (
                                        <TextField {...params} variant="outlined" />
                                    )}
                                />
                            </div>
                        </Grid>
                    </>
                ) : null}
            </Grid>
        </DialogContent>
    );
};

export default StepFour;
